import axios from "axios";

import { AbstractService } from "./abstract.service";
import { AuthService } from "@/services/auth.service";
import $store from "@/state/store"

export class LocationService extends AbstractService {
  static get entity() {
    return "n360/mcmnt/api";
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  // // tạo mới chi nhánh
  static async creatLocation(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY}/${this.entity}/location/create`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-app-id": process.env.VUE_APP_ID,
            "np-location-id": $store.state.auth.currentLocation
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  //  chi tiết chi nhánh
  static async getDetailLocation(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/location/detail`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // // cập nhật nhân viên
  // static async updateDeatilEmployee(params) {
  // try {
  //     const response = await axios.post(
  //     `${this.URL_GATEWAY}/${this.entity}/alias-user/update`,
  //     params,
  //     {
  //         headers: {
  //         Authorization: `Bearer ${AuthService.getBearer()}`,
  //         "np-merchant-id": params.merchantId,
  //         "np-app-id": process.env.VUE_APP_ID
  //         },
  //     }
  //     );
  //     return response.data;
  // } catch (error) {
  //     console.log(error);
  // }
  // }



  // Chi nhánh chính
  static async getMainLocation(){
    try {
      const response = await this.callApi().get(
        `${this.entity}/location/set-to-default`
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // xoá 1 chi nhánh
  static async deleteLocation(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/location/delete`,
        params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  // xoá nhiều chi nhánh
  static async deleteMultiLocation(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/location/delete-multiple`,
        params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async updateLocation(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/location/update`,params
      )
      return response.data
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }

  static async getListLocation(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/location/list`,
        params
      )
      return this.responseWrapper(response, response.data.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  //Loation has plan
  static async getListLocationDashboard() {
    try {
      const response = await this.callApi().get(
        `${this.entity}/locations`
      );
      return this.responseWrapper(response, response.data.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }

}
